var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "application-quick-actions-indicator" }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.left",
            value: _vm.$t("global.actions.gotToBottom"),
            expression: "$t('global.actions.gotToBottom')",
            modifiers: { left: true },
          },
        ],
        staticClass: "quick-action-item clickable bg-light-gray",
        on: { click: _vm.triggerScrollBottom },
      },
      [
        _c("icon", {
          staticClass: "text-white",
          attrs: { name: "chevron-down" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.left",
            value: _vm.$t("global.actions.chooseLanguage"),
            expression: "$t('global.actions.chooseLanguage')",
            modifiers: { hover: true, left: true },
          },
        ],
        staticClass: "quick-action-item clickable bg-light-gray",
      },
      [
        _c(
          "b-dropdown",
          {
            attrs: { variant: "link", "no-caret": "" },
            scopedSlots: _vm._u([
              {
                key: "button-content",
                fn: function () {
                  return [
                    _c("span", { staticClass: "text-white" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentLocale.shortVersion) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _vm._l(_vm.localeLanguageOptions, function (lang) {
              return _c(
                "b-dropdown-item",
                {
                  key: lang.id,
                  on: {
                    click: function ($event) {
                      return _vm.handleLanguageSelect(lang.id)
                    },
                  },
                },
                [
                  _vm._v("\n        " + _vm._s(lang.text) + "\n        "),
                  _vm.currentLocale.id === lang.id
                    ? _c("icon", { attrs: { name: "check" } })
                    : _vm._e(),
                ],
                1
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }